import script from "./notificationPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./notificationPopover.vue?vue&type=script&setup=true&lang=ts"

import "./notificationPopover.vue?vue&type=style&index=0&id=3f0022b2&lang=less"

const __exports__ = script;

export default __exports__